module.exports = __webpack_public_path__ + "media/fun/fun-5-0a7b50e6.jpg";